var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutorizaciones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.862,
    height: 47.968,
    viewBox: "0 0 37.862 47.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165631",
    "data-name": "Grupo 165631",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85669",
    "data-name": "Trazado 85669",
    d: "M14.961,5H9.98A4.98,4.98,0,0,0,5,9.98V39.862a4.98,4.98,0,0,0,4.98,4.98h24.9a4.98,4.98,0,0,0,4.98-4.98V9.98A4.98,4.98,0,0,0,34.882,5H29.9",
    transform: "translate(-5 0.125)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_148882",
    "data-name": "Rect\\xE1ngulo 148882",
    width: 15.698,
    height: 10.465,
    rx: 2,
    transform: "translate(9.526 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85670",
    "data-name": "Trazado 85670",
    d: "M9,14h.025",
    transform: "translate(0.961 13.536)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85671",
    "data-name": "Trazado 85671",
    d: "M9,17h.025",
    transform: "translate(0.961 18.007)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85672",
    "data-name": "Trazado 85672",
    d: "M12,18.98l2.49,2.49L21.961,14",
    transform: "translate(5.431 13.536)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorizaciones);
export default __webpack_public_path__ + "static/media/autorizaciones.6c6bd45b149006e701a0df732fceee8a.svg";
export { ForwardRef as ReactComponent };